import { render, staticRenderFns } from "./SelectTypeFilter.vue?vue&type=template&id=bcf7350a"
import script from "./SelectTypeFilter.vue?vue&type=script&lang=js"
export * from "./SelectTypeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports